export const API_BASE_URL = import.meta.env.VITE_ADMIN_API_URL;

export enum AppRoute {
    Root = '/',
    Login = '/login',
    Dashboard = '/dashboard',
    Statistics = '/statistics',
    Projects = '/projects',
    ProjectCreate = '/projects/create',
    ProjectDetail = '/projects/:id',
    ProjectEdit = '/projects/:id/edit',
    Scripts = '/projects/scripts',
    ScriptCreate = '/projects/:projectId/scripts/create',
    ScriptDetail = '/projects/:projectId/scripts/:id',
    ScriptEdit = '/projects/:projectId/scripts/:id/edit',
    Users = '/users',
    UserCreate = '/users/create',
    UserDetail = '/users/:id',
    UserEdit = '/users/:id/edit',
    UserProjects = '/users/:id/projects',
    Events = '/events',
    Objections = '/objections',
    ObjectionCreate = '/objections/create',
    ObjectionDetail = '/objections/:id',
    ObjectionEdit = '/objections/:id/edit',
    SupportTickets = '/support-tickets',
    Settings = '/settings',
    MyComments = '/my-comments',
    Comments = '/comments',
    Search = '/search',
    Changelog = '/changelog',
    Forbidden = '/403',
    NotFound = '/404',
    TooManyRequests = '/429',
    InternalServerError = '/500',
    Error = '/error',
    Unmatched = '*',
}

export enum ApiEndpoint {
    Login = '/api/login',
    CheckUser = '/api/check-user',
    Logout = '/api/logout',
    Changelog = '/api/dashboard/changelog',
    DashboardStats = '/api/dashboard/stats',
    ScriptWriterStats = '/api/dashboard/script-writer-stats',
    OnlineUsers = '/api/dashboard/online-users',
    Events = '/api/events',
    Objections = '/api/objections',
    Projects = '/api/projects',
    ProjectsReorder = '/api/projects/reorder',
    Users = '/api/users',
    ManagerProjects = '/api/dashboard/projects',
    ManagerScripts = '/api/dashboard/scripts',
    ManagerScriptAcknowledgeChanges = '/api/dashboard/scripts',
    SupportTickets = '/api/support-tickets',
    DashboardSupportTicket = '/api/dashboard/support-ticket',
    Settings = '/api/settings',
    SettingsAvailableKeys = '/api/settings/available-keys',
    Search = '/api/search',
    ScriptMedia = '/api/projects',
    ScriptsCopy = '/api/scripts/copy',
    ScriptComments = '/api/scripts',
    MyComments = '/api/dashboard/my-comments',
    AllComments = '/api/dashboard/comments',
}

export enum SupportTicketType {
    Bug = 'bug',
    Question = 'question',
    Error = 'error',
    Other = 'other',
}

export enum SupportTicketPriority {
    Low = 'low',
    Normal = 'normal',
    Critical = 'critical',
}

export enum SupportTicketStatus {
    New = 'new',
    InProgress = 'in_progress',
    Resolved = 'resolved',
}

export const SupportTicketTypes = {
    [SupportTicketType.Bug]: 'Баг',
    [SupportTicketType.Question]: 'Питання',
    [SupportTicketType.Error]: 'Помилка',
    [SupportTicketType.Other]: 'Інше',
};

export const SupportTicketPriorities = {
    [SupportTicketPriority.Low]: 'Низький',
    [SupportTicketPriority.Normal]: 'Нормальний',
    [SupportTicketPriority.Critical]: 'Критичний',
};

export const SupportTicketStatuses = {
    [SupportTicketStatus.New]: 'Новий',
    [SupportTicketStatus.InProgress]: 'В роботі',
    [SupportTicketStatus.Resolved]: 'Вирішено',
};

// TODO
// export const DARK_THEME_HTML_BACKGROUND_COLOR = '#e0e0e0';
export const DARK_THEME_HTML_BACKGROUND_COLOR = '#ADADAD';

/** Slug ключа налаштування → українська назва для UI та POST name */
export const SETTINGS_DISPLAY_NAME_BY_KEY: Record<string, string> = {
    default_instructions: 'Стандартні інструкції',
};

export const SETTING_KEY_DEFAULT_INSTRUCTIONS = 'default_instructions' as const;
